/* eslint-disable react-hooks/exhaustive-deps */
import { TvmConnectButton, useTvmWalletService } from '@broxus/tvm-connect/lib';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { DialogMission } from '@/components/Dialogs/DialogMission';
import { DialogMissionCompleted } from '@/components/Dialogs/DialogMissionCompleted';
import { Info } from '@/components/Info';
import { PageLayout } from '@/components/PageLayout';
import { Profile } from '@/components/Profile';
import { ProfileConnectWallet } from '@/components/Profile/components';
import { ProfileConnectedWallet } from '@/components/Profile/components/ConnectedWallet/ConnectedWallet';
import { Tabs } from '@/components/Tabs';
import { missionTabs } from '@/constants/missions';
import { currencyImg } from '@/constants/wallet';
import { useTabs } from '@/hooks';
import { useWallet } from '@/hooks/useWallet';
import { store } from '@/store';
import { StoreMission, Missions as TMissions } from '@/types/models/mission';

import { All as TabContent } from './components/Tabs/All';
import styles from './Missions.module.scss';

export const Missions = observer(() => {
  const { t } = useTranslation();
  const walletService = useTvmWalletService();

  useWallet(walletService);

  const { user, nextLevel, xpBar } = store.profile;
  const { badgesCount } = store.badges;
  const { currencyName } = store.wallet;

  const tabs = useTabs({
    initialTab: missionTabs.all,
    tabs: [
      { name: missionTabs.all, title: t('wallet.pages.missions.tabs.all') },
      {
        name: missionTabs.oneTime,
        title: t('wallet.pages.missions.tabs.oneTime'),
      },
      {
        name: missionTabs.repetitive,
        title: t('wallet.pages.missions.tabs.repetitive'),
      },
    ],
  });

  const {
    selectMission,
    setDialogMission,
    setDialogMissionComplete,
    selectedMission,
    dialogMission,
    dialogMissionComplete,
    selectedMissionProcessing,
    onAction,
  } = store.missions;

  // const { user, income, nextLevel, xpBar } = store.profile;
  // const { badgesCount } = store.badges;

  const { storeMissions } = store.app;

  const userStoreMissions = storeMissions(tabs.activeTab);

  const onMissionClick = useCallback(
    ({ mission, completed }: StoreMission) =>
      () => {
        if (completed) return;
        selectMission(mission);
        setDialogMission(true);
      },
    [],
  );

  const onDialogMissionClose = () => {
    setDialogMission(false);
  };

  const onDialogMissionAction = (mission?: TMissions | null) => {
    if (!mission) return;

    onAction(mission);
  };

  const onDialogMissionCheck = useCallback(
    async (mission?: TMissions | null) => {
      if (!mission) return;

      await store.app.checkMission(mission.externalId);
    },
    [],
  );

  const onDialogMissionCompleteAction = () => {
    setDialogMissionComplete(false);
  };

  console.log(userStoreMissions, 'userStoreMissions');

  return (
    <PageLayout className={styles.page}>
      <Profile
        badges={badgesCount}
        user={user}
        nextLevel={nextLevel}
        xpBar={xpBar}
      >
        <TvmConnectButton
          popupType="drawer"
          standalone={false}
          trigger={({ connect }) =>
            walletService.isConnected ? (
              <ProfileConnectedWallet
                balance={walletService.balance}
                address={walletService.address?.toString() || ''}
                onClick={walletService.disconnect}
                currency={currencyName}
                icon={currencyImg}
              />
            ) : (
              <ProfileConnectWallet onClick={connect} />
            )
          }
        />
      </Profile>
      <section className={'in-section'}>
        <h2 className="in-text-h2">{t('wallet.pages.missions.list')}</h2>
        <Tabs {...tabs} />
        {!userStoreMissions.length && (
          <Info>
            <span className="in-text-16 in-text-pre-line">
              {t('wallet.pages.missions.emptyList')}
            </span>
          </Info>
        )}
        <TabContent missions={userStoreMissions} onClick={onMissionClick} />
      </section>
      <DialogMission
        loading={selectedMissionProcessing}
        mission={selectedMission}
        isOpen={dialogMission}
        onClose={onDialogMissionClose}
        onCheck={onDialogMissionCheck}
        onAction={onDialogMissionAction}
      />
      <DialogMissionCompleted
        mission={selectedMission}
        isOpen={dialogMissionComplete}
        onAction={onDialogMissionCompleteAction}
        onClose={onDialogMissionCompleteAction}
      />
    </PageLayout>
  );
});

export default Missions;
